import {Component, OnInit} from '@angular/core';
import {Constants, redirectToLink} from '../../common/constants';
import {DeviceDetectorService} from 'ngx-device-detector';
import {SessionService} from '../../../services/session.service';
import { Router } from '@angular/router';
import packageInfo from "../../../../../package.json";

@Component({
    selector: 'app-template',
    templateUrl: './template.component.html',
    styleUrls: ['./template.component.scss']
})
export class TemplateComponent implements OnInit {
    /* VARIABLES PARA SABER SI SON MOVILES */
    isMobile: any = false;
    isTablet: any = false;

    constructor(
        private deviceService: DeviceDetectorService,
        private sessionService: SessionService,
        public router:Router,
    ) {
        this.isMobile = this.deviceService.isMobile();
        this.isTablet = this.deviceService.isTablet();
    }

    ngOnInit(): void {

        /* LOCALIZACION */
        this.sessionService.getLocationUser().subscribe(
            (response: any) => {
                if (response) {
                    this.sessionService.getCountrieUser(response.location.lat, response.location.lng).subscribe(
                        (responseCountrie: any) => {
                            this.sessionService.setCountryData(this.getDatos(responseCountrie.results));
                        }
                    );
                }
            }
        );

        if (!this.sessionService.getAuthData()) {
            const userPay = Constants.decryptData(Constants.configSession.userK, Constants.configSession.userP);
            const passwordPay = Constants.decryptData(Constants.configSession.passK, Constants.configSession.passP);
            this.sessionService.login(userPay, passwordPay, true).subscribe(
                responseLogin => {
                    this.sessionService.setDayExpiration();
                    this.sessionService.setAuthData(responseLogin);
                    this.sessionService.setLoginSession(null);
                }
            );
        } else {
            if (this.sessionService.getDayExpiration() !== String(new Date().getDate() + '/' + new Date().getMonth())) {
                this.sessionService.newDataSession();
            }
        }
        console.log('v' + packageInfo.version);
    }

    openLink(link): void {
        redirectToLink(link);
    }

    getDatos(paises: any): any {
        let mex = false;
        paises.forEach(
            pais => {
                pais.address_components.forEach(
                    address => {
                        const data = address.types.find(type => type === 'country');
                        if (data) {
                            if (address.short_name === 'MX') {
                                mex = true;
                            }
                        }
                    }
                );
            }
        );
        return mex;
    }

}
